import React from 'react';
import Header from './header';
import { Box } from '@mui/material';

const Layout: React.FC<React.PropsWithChildren<{}>> = ({ children }) => {
  return (
    <Box sx={{ 
      height: '100vh', 
      minHeight: '100vh', 
      bgcolor: '#000', 
      color: 'hsl(19 101% 51% / 1)',
      display: 'flex',
      flexDirection: 'column',
      overflowY: 'hidden'
    }}>
      <Header />
      <Box sx={{ 
        flex: 1, 
        height: '98%',
        overflowX: 'auto',
        p: 1
      }}>
        {children}
      </Box>
    </Box>
  );
};

export default Layout;
